var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CrearOT"}},[_c('b-button',{attrs:{"variant":"action"},on:{"click":function($event){return _vm.redirectToCreateOT()}}},[_vm._v("Crear OT")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }